export function resolveAlertSettingsRowLabel({
  category,
  value,
  translate,
  translationExists
}) {
  if (category) {
    const labelKey = `alert_category_${category}`;

    if (translationExists(labelKey)) {
      return translate(labelKey);
    }
  }

  return translate(value);
}
